import { useSessionStore } from './useSessionStore.js';
import { useWorkbenchContextStore } from './useWorkbenchContextStore.js';
import { useAppStore } from './useAppStore.js';
import { useConnectionProfileStore } from './useConnectionProfileStore.js';
import { useGisStore } from './useGisStore.js';
import { useIntegrationStore } from './useIntegrationStore.js';
import { useMessageStore } from './useMessageStore.js';
import { useSimulationExecutionStore } from './useSimulationExecutionStore.js';
import { useTestSuiteStore } from './useTestSuiteStore.js';
import { useSimulationTestStore } from './useSimulationTestStore.js';

export const resetProjectDependentStores = () => {
  useSimulationTestStore.setState({
    tests: [],
    selectedTestId: null,
    isLoading: false,
    error: null,
  });
  useSimulationExecutionStore.getState().stopExecution();
  useSimulationExecutionStore.getState().reset();
  useConnectionProfileStore.setState({
    profiles: [],
    selectedProfileId: null,
    isLoading: false,
    error: null,
  });
  useIntegrationStore.setState({
    adapters: {},
    packets: [],
    isImporting: false,
    importError: null,
  });
  useGisStore.getState().reset();
  useMessageStore.setState({ messages: [] });
  useTestSuiteStore.setState({
    suites: [],
    cases: [],
    selectedSuiteId: null,
    selectedCaseId: null,
    isLoading: false,
    error: null,
  });
  useSessionStore.getState().reset();
  useWorkbenchContextStore.getState().resetAll();
};

export const resetAllStores = () => {
  resetProjectDependentStores();
  useAppStore.setState({ currentProjectId: null });
};

export const setCurrentProjectId = (projectId: string | null) => {
  useAppStore.setState({ currentProjectId: projectId });
};
